/**
 * Global SEO defaults and base URL for the Focuzon application.
 * Used by SEOMeta component and sitemap/robots.
 *
 * URL best practices applied across the site:
 * - Human-readable, semantically accurate paths (e.g. /blog/how-to-increase-productivity)
 * - Hyphens to separate words (not underscores or spaces)
 * - Lowercase only (avoids duplicate content from moz.com/Blog vs moz.com/blog)
 * - No trailing slash on paths (canonical consistency)
 * - Avoid URL parameters when possible
 */

export const SEO_BASE_URL = 'https://focuzon.com';

export const SEO_DEFAULTS = {
  title: 'Focuzon | Deep Work, Pomodoro Timer & Task Management Tool',
  description:
    'Focuzon helps you stay focused using Pomodoro timers, deep work sessions and productivity tools.',
  ogTitle: 'Focuzon Productivity Platform',
  ogDescription: 'Pomodoro timer, deep work sessions and task management tools.',
  ogType: 'website' as const,
  twitterCard: 'summary_large_image' as const,
};

/** Build full canonical or OG URL from path (path should start with /) */
export function seoUrl(path: string): string {
  const base = SEO_BASE_URL.replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}
